'use strict';

import { setCookie, getCookie } from '../common/cookie';

$(() => {
    var $publines = $('.js-publine');

    if (!$publines.length) {
        $('.cc-page').addClass('cc-publine-empty');
        return;
    }

    var hiddenClass = 'cc-em-publine--hidden';
    var visibleClass = 'cc-em-publine--visible';
    var dismissedClass = 'cc-em-publine--dismissed';
    var revealingClass = 'cc-em-publine--revealing';
    var visibilityEventNamespace = '.publineVisibility';
    var revealEventNamespace = '.publineReveal';
    var showScrollThreshold = 10;
    var hideScrollThreshold = 50;

    function showPubline($publine) {
        if ($publine.hasClass(dismissedClass)) {
            return;
        }

        if (
            $publine.hasClass(visibleClass) &&
            !$publine.hasClass(hiddenClass)
        ) {
            return;
        }

        var isRevealing =
            window.isDesktop &&
            $publine.hasClass(hiddenClass);

        $publine.off(visibilityEventNamespace);
        $publine.off(revealEventNamespace);
        $publine.removeClass('d-none');

        if (isRevealing) {
            $publine.addClass(revealingClass);
        }

        // Force reflow so the transition runs correctly.
        void $publine[0].offsetWidth;

        $publine
            .removeClass(hiddenClass)
            .addClass(visibleClass);

        if (isRevealing) {
            $publine.one(
                'transitionend.publineReveal webkitTransitionEnd.publineReveal',
                function (event) {
                    var propertyName = event.originalEvent
                        ? event.originalEvent.propertyName
                        : event.propertyName;

                    if (
                        event.target !== $publine[0] ||
                        propertyName !== 'opacity'
                    ) {
                        return;
                    }

                    $publine
                        .removeClass(revealingClass)
                        .off(revealEventNamespace);
                }
            );
        }
    }

    function hidePubline($publine, onHidden, keepInFlow) {
        if ($publine.hasClass(dismissedClass)) {
            return;
        }

        if ($publine.hasClass(hiddenClass)) {
            if (!keepInFlow) {
                $publine.addClass('d-none');
            }

            if (typeof onHidden === 'function') {
                onHidden();
            }

            return;
        }

        $publine
            .off(visibilityEventNamespace)
            .off(revealEventNamespace)
            .removeClass(revealingClass);

        $publine
            .removeClass(visibleClass)
            .addClass(hiddenClass);

        $publine.one(
            'transitionend.publineVisibility webkitTransitionEnd.publineVisibility',
            function (event) {
                var propertyName = event.originalEvent
                    ? event.originalEvent.propertyName
                    : event.propertyName;

                if (
                    event.target !== $publine[0] ||
                    propertyName !== 'opacity'
                ) {
                    return;
                }

                if (
                    $publine.hasClass(hiddenClass) &&
                    !keepInFlow
                ) {
                    $publine.addClass('d-none');
                }

                $publine.off(visibilityEventNamespace);

                if (typeof onHidden === 'function') {
                    onHidden();
                }
            }
        );
    }

    function updatePublineVisibility() {
        var currentScroll = $(window).scrollTop();
        var isPublineDismissed = Boolean(getCookie('publine'));

        $publines.each(function () {
            var $publine = $(this);

            if (isPublineDismissed) {
                return;
            }

            if (currentScroll < showScrollThreshold) {
                showPubline($publine);
            } else if (currentScroll >= hideScrollThreshold) {
                /*
                 * false means the publine receives d-none after hiding,
                 * so it does not leave empty space below the header.
                 */
                hidePubline($publine, null, false);
            } else if (
                !$publine.hasClass(hiddenClass) &&
                !$publine.hasClass(visibleClass)
            ) {
                showPubline($publine);
            }
        });
    }

    $(window).on('scroll.publineVisibility', function () {
        updatePublineVisibility();
    });

    $publines.each(function () {
        var $publine = $(this);
        var $textBlocks = $publine.find(
            '.cc-em-publine--textBlocks'
        );
        var $textItems = $textBlocks.find(
            '.cc-em-publine--textBlock'
        );
        var $pauseBtn = $publine.find('.js-pausePubline');
        var $playBtn = $publine.find('.js-playPubline');
        var $closeBtn = $publine.find('.js-hidePubline');

        var cookieDuration =
            parseInt($publine.data('cookie-duration'), 10) * 24 || 24;

        var scrollSpeed =
            parseInt($publine.data('scroll-speed'), 10) || 10000;

        var isPublineDismissed = Boolean(getCookie('publine'));

        var currentIndex = 0;
        var isPlaying = false;
        var isAnimating = false;
        var textCount = $textItems.length;
        var hasOverflow = false;

        $publine[0].style.setProperty(
            '--publine-scroll-speed',
            `${scrollSpeed}ms`
        );

        function updateOverflowState() {
            var $content = $publine.find(
                '.cc-em-publine--content'
            );

            if (!textCount || !$content.length) {
                hasOverflow = false;
                return;
            }

            hasOverflow =
                $content[0].scrollWidth >
                $content[0].clientWidth;
        }

        function updateButtonVisibility() {
            updateOverflowState();

            var shouldShowControls =
                hasOverflow || textCount > 1;

            if (!shouldShowControls) {
                $playBtn.addClass('d-none');
                $pauseBtn.addClass('d-none');
                return;
            }

            if (isPlaying) {
                $playBtn.addClass('d-none');
                $pauseBtn.removeClass('d-none');
            } else {
                $playBtn.removeClass('d-none');
                $pauseBtn.addClass('d-none');
            }
        }

        function setButtonVisibility(show) {
            var shouldShowControls =
                hasOverflow || textCount > 1;

            if (show && shouldShowControls) {
                if (isPlaying) {
                    $pauseBtn.removeClass('d-none');
                    $playBtn.addClass('d-none');
                } else {
                    $playBtn.removeClass('d-none');
                    $pauseBtn.addClass('d-none');
                }

                return;
            }

            $playBtn.addClass('d-none');
            $pauseBtn.addClass('d-none');
        }

        function showText(index) {
            $textItems.removeClass('is-active');
            $textItems.eq(index).addClass('is-active');
            currentIndex = index;
        }

        function scrollCurrentText() {
            if (!isPlaying || isAnimating) {
                return;
            }

            if (textCount <= 1 && !hasOverflow) {
                return;
            }

            isAnimating = true;
            $textBlocks.addClass('is-scrolling');
        }

        function togglePlay() {
            isPlaying = !isPlaying;

            if (isPlaying) {
                $textBlocks.removeClass('is-paused');

                if (!isAnimating) {
                    scrollCurrentText();
                }
            } else {
                $textBlocks.addClass('is-paused');
            }

            setButtonVisibility(true);
        }

        $textBlocks.on('animationend', function () {
            $textBlocks.removeClass('is-scrolling');
            isAnimating = false;

            if (!isPlaying) {
                updateButtonVisibility();
                return;
            }

            if (textCount > 1) {
                currentIndex =
                    (currentIndex + 1) % textCount;

                showText(currentIndex);
            }

            setTimeout(scrollCurrentText, 100);
            updateButtonVisibility();
        });

        if (textCount > 0) {
            showText(0);
        }

        $playBtn.on('click', togglePlay);
        $pauseBtn.on('click', togglePlay);

        $(window).on('resize.publine', function () {
            updateOverflowState();

            if (!hasOverflow) {
                $textBlocks.removeClass(
                    'is-paused is-scrolling'
                );

                isAnimating = false;
                isPlaying = false;
            }

            updateButtonVisibility();
        });

        if (!isPublineDismissed) {
            $closeBtn.on('click', function () {
                setCookie(
                    'publine',
                    true,
                    cookieDuration
                );

                /*
                 * Dismissal keeps the layout space to prevent the
                 * desktop content from shifting upward.
                 */
                $publine
                    .off(visibilityEventNamespace)
                    .removeClass('d-none')
                    .removeClass(hiddenClass)
                    .addClass(visibleClass)
                    .addClass(dismissedClass);
            });
        } else {
            /*
             * Keep stable layout when the page loads with the
             * dismissal cookie already present.
             */
            $publine
                .removeClass('d-none')
                .removeClass(hiddenClass)
                .addClass(visibleClass)
                .addClass(dismissedClass);
        }

        updateButtonVisibility();
    });

    updatePublineVisibility();
});